export default __webpack_public_path__ + "static/media/airstrapz-bpk-2.794e04a0.png";